import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export function initRelatedCaseStudiesCarousel() {
  var el = document.querySelector(".related-case-studies-swiper");
  if (!el) return;

  var nav = document.querySelector(".related-case-studies-nav");

  var swiper = new Swiper(el, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,

    navigation: {
      prevEl: "[data-case-studies-prev]",
      nextEl: "[data-case-studies-next]",
    },

    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  function toggleNavigation() {
    if (!nav) return;

    // Show navigation on mobile/tablet
    if (window.innerWidth < 992) {
      nav.hidden = false;
      swiper.navigation.update();
      return;
    }

    // Count only original slides
    var totalSlides = swiper.slides.filter(function (slide) {
      return !slide.classList.contains("swiper-slide-duplicate");
    }).length;

    // Hide navigation on desktop when 3 or fewer slides
    nav.hidden = totalSlides <= 3;

    // Update disabled state
    swiper.navigation.update();
  }

  // Initial call
  toggleNavigation();

  swiper.on("update", toggleNavigation);
  swiper.on("breakpoint", toggleNavigation);
  swiper.on("slideChange", function () {
    swiper.navigation.update();
  });

  window.addEventListener("resize", toggleNavigation);
}